export default __webpack_public_path__ + "static/media/pause_icon.dc6efe75.svg";